export default {
  // 更新token
  v3_authorization (state, val) {
    state.authorization = val
    state.authorization === '' ? window.sessionStorage.removeItem('authorization') : window.sessionStorage.setItem('authorization', state.authorization)
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js